import crudActions from '../../crud/actions'

const actions = crudActions('CAREPLAN_VISITS_')

export default actions
